// API Configuration
export const API_CONFIG = {
  // Base URL for API calls
  BASE_URL: process.env.REACT_APP_API_BASE || 'http://localhost:7000/api',
  
  // Timeout for requests (in milliseconds)
  TIMEOUT: 60000,
  
  // Default headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },
  
  // Development mode flag
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  
  // Debug mode flag
  DEBUG: process.env.REACT_APP_DEBUG === 'true',
};

// Helper function to log API calls in development
export const logApiCall = (method, url, data = null) => {
  if (API_CONFIG.DEBUG) {
    console.log(`[API] ${method.toUpperCase()} ${url}`, data);
  }
};

// Helper function to log API responses in development
export const logApiResponse = (method, url, response) => {
  if (API_CONFIG.DEBUG) {
    console.log(`[API] ${method.toUpperCase()} ${url} - Response:`, response);
  }
};

// Helper function to log API errors in development
export const logApiError = (method, url, error) => {
  if (API_CONFIG.DEBUG) {
    console.error(`[API] ${method.toUpperCase()} ${url} - Error:`, error);
  }
};
